import { trackSigninSignUpModalPrivatePolicyClick } from "@faire/web-api--source/events/signin/click/signUpModalPrivatePolicy";
import { trackSignupSignUpModalTermsClick } from "@faire/web-api--source/events/signup/click/signUpModalTerms";
import privacyPath from "@faire/web-api--source/routes/www/privacy";
import termsOfService from "@faire/web-api--source/routes/www/tos";
import { Button } from "@faire/web/slate/Button";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React, { type JSX } from "react";
import styled from "styled-components";

export const TermsAndPrivacyPolicyDisclaimer = () => (
  <StrictLocalMsg
    id="7MWdTe"
    defaultMessage="By proceeding, you agree to our <TosLinkFormatting>Terms</TosLinkFormatting> and <PrivacyLinkFormatting>Privacy Policy</PrivacyLinkFormatting>."
    values={{
      TosLinkFormatting,
      PrivacyLinkFormatting,
    }}
    description={{
      text: "Terms and privacy policy disclaimer message for proceeding in sign up process",
      img: "https://cdn.faire.com/fastly/24c7e5515309bee2ef49c451d774bb0a2d90bb2e32fbb81fb2d472a6dfc579d2.png",
    }}
  />
);

const TosLinkFormatting = (chunks: JSX.Element) => (
  <SubduedEmbeddedLink
    linkTo={termsOfService()}
    onClick={trackSignupSignUpModalTermsClick}
  >
    {chunks}
  </SubduedEmbeddedLink>
);

const PrivacyLinkFormatting = (chunks: JSX.Element) => (
  <SubduedEmbeddedLink
    linkTo={privacyPath()}
    onClick={trackSigninSignUpModalPrivatePolicyClick}
  >
    {chunks}
  </SubduedEmbeddedLink>
);

const SubduedEmbeddedLink = styled(Button).attrs({
  variant: "tertiary",
  target: "_blank",
})`
  color: inherit;
  text-decoration-color: inherit;
  font-size: 12px; // Custom font size to match rest of disclaimer text
`;
